import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offers-page',
  templateUrl: './offers-page.component.html',
  styleUrls: ['./offers-page.component.scss']
})
export class OffersPageComponent implements OnInit {

  public section1 = { title: 'Bisogno di aiuto?', description: "Lasciati consigliare dai nostri esperti, contattarci è facile e veloce!",
  ctaLink: "/contatti", ctaText: "Contattaci", bgUrl: "../assets/work2.jpg" }


  constructor() { }

  ngOnInit() {
    window.scrollTo(0,0);
  }

}
